import type { ThemeColors } from '../../../../tokens/colors/types';

export const purple: ThemeColors['purple'] = {
  '20': '#EFEBF9',
  '30': '#C4B8EA',
  '50': '#7B61D1',
  '70': '#5335B6',
  '90': '#38247B',
};

export const blue: ThemeColors['blue'] = {
  '20': '#E9F5FE',
  '30': '#84BBD2',
  '50': '#308BB2',
  '70': '#226596',
  '90': '#22617C',
};

export const green: ThemeColors['green'] = {
  '20': '#E2F4EE',
  '30': '#75C5B8',
  '50': '#209B87',
  '70': '#036C5E',
  '90': '#146154',
};

export const orange: ThemeColors['orange'] = {
  '20': '#F8E9D4',
  '30': '#ECB25F',
  '50': '#E3911C',
  '70': '#C0750C',
  '90': '#965C08',
};

export const red: ThemeColors['red'] = {
  '20': '#F6E1E4',
  '30': '#EA8785',
  '50': '#DA3835',
  '70': '#8C0A00',
  '90': '#921916',
};

export const neutral: ThemeColors['neutral'] = {
  '0': '#FFFFFF',
  '10': '#F7F7F8',
  '20': '#F7F7F7',
  '30': '#F2F2F2',
  '40': '#E6E6E6',
  '50': '#92929C',
  '60': '#B2B2B2',
  '70': '#66666D',
  '80': '#6F6F6F',
  '90': '#4C4C4C',
  '100': '#1C1C1E',
};

export const pale: ThemeColors['pale'] = {
  '10': '#F8F7F1',
  '20': '#EAE7D6',
  '100': '#433F26',
};
